import React, { useState, useEffect, useRef } from 'react';
import {
    Tabs,
    Tab,
    Typography,
    Box,
    Badge,
    Card,
    ListItem,
    styled,
    List,
    Grid
} from '@mui/material';

import { Link } from 'react-router-dom';
import { green, grey, yellow } from '@mui/material/colors';

import CommonBreadcumbs from "../../../components/common/CommonBreadcumbs"
import { CommonIcons, icons } from '../../../components/common/CommonIcons';

import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes'

import { useSystemPrompt } from '../../../hooks/useSystemPrompt';
import { useTranslations } from "../../../hooks/useTranslations";

// import {
//     customInjectionProps as deliveryOrderInjectionProps
// } from "../schema/documents/GenerateFromContainerDOSchema"

// import {
//     customInjectionProps as itemReceiveInjectionProps
// } from "../schema/documents/GenerateFromContainerIRSchema"

import {
    customInjectionProps as productInjectionProps
} from "../schema/items/productSchema"

import {
    customInjectionProps as itemInjectionProps
} from "../schema/items/itemSchema"

import {
    customInjectionProps as containerInjectionProps
} from "../schema/repositories/containerSchema"


import {
    customInjectionProps as customerInjectionProps
} from "../schema/user/customerSchema"

import {
    customInjectionProps as customerBranchInjectionProps
} from "../schema/user/branchSchema"

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));


const injectionPropsIndexes = {
    document: {
        id: "document",
        primaryId: "document_id",
        shortName: "doc",
        tableName: "cl_document_injection_props"
    },
    product: {
        id: "product",
        primaryId: "product_id",
        shortName: "prod",
        tableName: "cl_item_injection_props"
    },
    item: {
        id: "item",
        primaryId: "item_id",
        shortName: "item",
        tableName: "cl_item_injection_props"
    },
    category: {
        id: "category",
        primaryId: "category_id",
        shortName: "cat",
        tableName: "cl_item_injection_props"
    },
    repository: {
        id: "repository",
        primaryId: "repository_id",
        shortName: "repo",
        tableName: "cl_repository_injection_props"
    },
    logistic: {
        id: "logistic",
        primaryId: "logistic_id",
        shortName: "logis",
        tableName: "cl_logistic_injection_props"
    },
    user: {
        id: "user",
        primaryId: "user_id",
        shortName: "user",
        tableName: "cl_user_injection_props"
    }
}

export default function Configuration({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "_@configuration"] })

    const { promptMessage } = useSystemPrompt()

    const [value, setValue] = React.useState(0);

    const { getRoute } = useSystemRoutes(routeType)

    const [counter, setCounter] = useState(0);
    const timer = useRef(null); // we can save timer in useRef and pass it to child

    const [dataNotification, setDataNotification] = useState({})

    const RenderDisplayItem = ({
        data
    }) => {

        const {
            submitKey: display,
            retrieveKey: value,
            propFieldId
        } = data

        return (
            <ListItem
                divider
                sx={{
                    p: 1,
                    pl: 2,
                    display: 'flex',
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "center",
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: "row",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        width: '100%'
                    }}
                >
                    <CommonIcons name={icons.burger} />
                    <Typography
                        sx={{
                            ml: 1,
                            fontSize: 14
                        }}
                    >
                        {`${display}`}
                    </Typography>
                </Box>
                <Typography
                    sx={{
                        color: grey[500],
                        fontSize: 12
                    }}
                >
                    {value} ({propFieldId})
                </Typography>
            </ListItem>
        )

    }

    const RenderItemInjectionProps = ({ title, sourceData }) => {

        return (
            <StyledCard
                sx={{
                    p: 0
                }}
            >
                <Typography
                    sx={{
                        fontWeight: 800,
                        fontSize: 18,
                        px: 2,
                        pt: 2
                    }}
                >
                    {title}
                </Typography>
                <List>
                    {
                        Object.keys(sourceData).map((i, index) => {
                            return (
                                <RenderDisplayItem
                                    key={index}
                                    data={sourceData[i]}
                                // display={i}
                                // value={itemInjectionProps[i]}
                                />
                            )
                        })
                    }
                </List>
            </StyledCard>
        )
    }


    const RenderItemInjectionPropsIndexing = ({
        title,
        injectionProps,
        indexingId
    }) => {

        let indexing = injectionPropsIndexes[indexingId]

        return (
            <StyledCard
                sx={{
                    p: 2
                }}
            >
                <Typography
                    sx={{
                        fontWeight: 800,
                        fontSize: 18,
                    }}
                >
                    {title}
                </Typography>
                <Box>
                    {
                        Object.keys(injectionProps).map((i, index) => {

                            let item = injectionProps[i]

                            let sql = getIndexSql({ key: item.submitKey, index: indexing })

                            return (
                                <Typography
                                    key={index}
                                    sx={{
                                        fontSize: 13
                                    }}
                                >
                                    {sql}
                                </Typography>
                            )
                        })
                    }
                </Box>
            </StyledCard>
        )
    }

    const getIndexSql = ({ key, index }) => {

        const {
            primaryId, shortName, tableName
        } = index

        let indexName = `idx_${shortName}_inj_${primaryId}_${key.toLowerCase()}`

        let sql = `CREATE INDEX ${indexName} ON `
        sql += `${tableName} (${primaryId},type) `
        sql += `WHERE (type='${key.toUpperCase()}') ;`

        return sql
    }

    return (
        <Box>

            <CommonBreadcumbs
                routeType={routeTypes.workstation}
                pageTitle={
                    t(`configuration`)
                }
                breadcrumbs={[
                    {
                        displayText: `${t('configuration')} (*)`,
                        props: {
                            // underline: "hover",
                            // href: "/"
                        }
                    }
                ]}
            />

            <Grid container spacing={2}>
                <Grid item md={4}>
                    <RenderItemInjectionProps
                        title={t(`containerProps`)}
                        sourceData={containerInjectionProps}
                    />
                </Grid>
                <Grid item md={4}>
                    <RenderItemInjectionProps
                        title={t(`productProps`)}
                        sourceData={productInjectionProps}
                    />
                </Grid>
                <Grid item md={4}>
                    <RenderItemInjectionProps
                        title={t(`itemProps`)}
                        sourceData={itemInjectionProps}
                    />
                </Grid>
                <Grid item md={4}>
                    <RenderItemInjectionProps
                        title={t(`customerProps`)}
                        sourceData={customerInjectionProps}
                    />
                </Grid>
                <Grid item md={4}>
                    <RenderItemInjectionProps
                        title={t(`customerBranchProps`)}
                        sourceData={customerBranchInjectionProps}
                    />
                </Grid>
                {/* <Grid item md={4}>
                    <RenderItemInjectionProps
                        title={t(`deliveryOrderProps`)}
                        sourceData={deliveryOrderInjectionProps}
                    />
                </Grid> */}
                {/* <Grid item md={4}>
                    <RenderItemInjectionProps
                        title={t(`itemReceiveProps`)}
                        sourceData={itemReceiveInjectionProps}
                    />
                </Grid> */}
            </Grid>

            <Grid item md={12}>
                <RenderItemInjectionPropsIndexing
                    title={`Indexing Container`}
                    injectionProps={containerInjectionProps}
                    indexingId={injectionPropsIndexes.repository.id}
                />
            </Grid>
            <Grid item md={12}>
                <RenderItemInjectionPropsIndexing
                    title={`Indexing Product`}
                    injectionProps={productInjectionProps}
                    indexingId={injectionPropsIndexes.item.id}
                />
            </Grid>
            <Grid item md={12}>
                <RenderItemInjectionPropsIndexing
                    title={`Indexing Customer`}
                    injectionProps={customerInjectionProps}
                    indexingId={injectionPropsIndexes.user.id}
                />
            </Grid>
            <Grid item md={12}>
                <RenderItemInjectionPropsIndexing
                    title={`Indexing Customer Branch`}
                    injectionProps={customerBranchInjectionProps}
                    indexingId={injectionPropsIndexes.user.id}
                />
            </Grid>
            {/* <Grid item md={12}>
                <RenderItemInjectionPropsIndexing
                    title={`Indexing Delivery Order`}
                    injectionProps={deliveryOrderInjectionProps}
                    indexingId={injectionPropsIndexes.document.id}
                />
            </Grid> */}
            {/* <Grid item md={12}>
                <RenderItemInjectionPropsIndexing
                    title={`Indexing Item Receive`}
                    injectionProps={itemReceiveInjectionProps}
                    indexingId={injectionPropsIndexes.document.id}
                />
            </Grid> */}

            {/* <Box sx={{ width: '100%' }}>
                {
                    JSON.stringify(pickInjectionProps)
                }
                {
                    JSON.stringify(stagingInjectionProps)
                }
            </Box> */}

        </Box>
    );
}
